import React from 'react';
import { useSelector } from 'react-redux';
import { selectCities } from '../../../redux/reducers/CitiesReducer';

import { selectMunicipalities } from '../../../redux/reducers/MunicipalitiesReducer';
import { selectSchools } from '../../../redux/reducers/SchoolsReducer';
import { selectSchoolTypes } from '../../../redux/reducers/SchoolTypesReducer';

import Filters from '../../common/Filters/Filters';

interface Props {
  filters: Record<string, string>;
  setFilter: (filter: string, value: string) => void;
}

const StudentsFilters = ({ filters, setFilter }: Props) => {
  const municipalities = useSelector(selectMunicipalities);
  const cities = useSelector(selectCities);
  const schools = useSelector(selectSchools);
  const schoolTypes = useSelector(selectSchoolTypes);

  const citiesInMunicipalityIds = Object.values(cities)
    .filter(
      ({ municipalityId }) =>
        municipalityId.toString(10) === filters.municipality,
    )
    .map(({ id }) => id);

  return (
    <Filters
      className="d-flex flex-column gap-3 align-items-stretch"
      setFilter={setFilter}
      values={filters}
      filtersSchema={{
        username: {
          type: 'input',
          placeholder: 'ID',
        },
        municipality: {
          type: 'select',
          onChange: () => {
            setFilter('city', '');
            setFilter('school', '');
          },
          options: [
            { value: '', label: 'Любой муниципалитет' },
            ...Object.values(municipalities).map(({ id, name }) => ({
              value: id.toString(10),
              label: name,
            })),
          ],
        },
        city: {
          type: 'select',
          onChange: () => {
            setFilter('school', '');
          },
          options: [
            { value: '', label: 'Любой город' },
            ...Object.values(cities)
              .filter(
                ({ municipalityId }) =>
                  municipalityId.toString(10) === filters.municipality,
              )
              .map(({ id, name }) => ({
                value: id.toString(10),
                label: name,
              })),
          ],
        },
        schoolType: {
          type: 'select',
          options: [
            { value: '', label: 'Любой тип ОО' },
            ...Object.values(schoolTypes).map(({ id, name }) => ({
                value: id.toString(10),
                label: name,
              })),
          ],
        },
        school: {
          type: 'select',
          options: [
            { value: '', label: 'Любая школа' },
            ...Object.values(schools)
              .filter(
                ({ cityId }) =>
                  cityId.toString(10) === filters.city ||
                  citiesInMunicipalityIds.includes(cityId),
              )
              .map(({ id, name }) => ({
                value: id.toString(10),
                label: name,
              })),
          ],
        },
        sex: {
          type: 'select',
          options: [
            { label: 'Любой пол', value: '' },
            { label: 'м', value: 'м' },
            { label: 'ж', value: 'ж' },
          ],
        },
        age: {
          type: 'input',
          placeholder: 'Возраст',
        },
        grade: {
          type: 'input',
          placeholder: 'Класс',
        },
        gradeLetter: {
          type: 'input',
          placeholder: 'Буква класса',
        },orphan: {
          type: 'select',
          options: [
            { label: 'Сирота - Любой', value: '' },
            { label: 'Сирота - Нет', value: '0' },
            { label: 'Сирота - Да', value: '1' },
          ],
        },
        visionImpairment: {
          type: 'select',
          options: [
            { label: 'НЗ - Любой', value: '' },
            { label: 'НЗ - Нет', value: '0' },
            { label: 'НЗ - Да', value: '1' },
          ],
        },
        hearingImpairment: {
          type: 'select',
          options: [
            { label: 'НС - Любой', value: '' },
            { label: 'НС - Нет', value: '0' },
            { label: 'НС - Да', value: '1' },
          ],
        },
        musculoskeletalImpairment: {
          type: 'select',
          options: [
            { label: 'НОДА - Любой', value: '' },
            { label: 'НОДА - Нет', value: '0' },
            { label: 'НОДА - Да', value: '1' },
          ],
        },
        doneTesting: {
          type: 'select',
          options: [
            { label: 'Прошёл - Любой', value: '' },
            { label: 'Прошёл - Нет', value: '0' },
            { label: 'Прошёл - Да', value: '1' },
          ],
        },
        result: {
          type: 'select',
          options: [
            { label: 'Вероятность риска - Любая', value: '' },
            { label: 'Вероятность риска - Низкая', value: '0' },
            { label: 'Вероятность риска - Высокая', value: '1' },
            { label: 'Вероятность риска - Высочайшая', value: '2' },
          ],
        },
      }}
    />
  );
};

export default StudentsFilters;
